import { SearchInput } from '@billy/design-system'
import React, { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountFilters } from '../../hooks/useAccountFilters'

export const AccountTableSearch = (): ReactElement => {
  const { t } = useTranslation()
  const [{ searchQuery }, setQueryParams] = useAccountFilters()

  const isSearchInputFocused = !!searchQuery

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setQueryParams({ page: 1, searchQuery: event.target.value || undefined })
    },
    [setQueryParams],
  )

  const handleClear = useCallback(() => {
    setQueryParams({ page: 1, searchQuery: undefined })
  }, [setQueryParams])

  return (
    <SearchInput
      focused={isSearchInputFocused}
      onChangeDebounced={handleChange}
      onClear={handleClear}
      placeholder={`${t('search')}...`}
      value={searchQuery}
    />
  )
}
